import { Alert, AlertDescription, AlertTitle, Box, Button } from "@chakra-ui/react";
import { useCallback } from "react";
import { AlertIcon } from "view-layer/components/common/icons/AlertIcon";


export const PendingPaymentForOxxo = ({ nextAction }: { nextAction: any }) => {
  const nextActionDetails = nextAction?.oxxo_voucher || nextAction?.details; // for backwards compatibility
  // test
  const { url } = nextActionDetails || {};

  const onViewVoucher = useCallback(() => {
    if (url) window.location.replace(url);
  }, [url]);

  return (
    <Box>
      <Alert status="success" variant="success" data-testid="payment-pending-message">
        <AlertIcon status="oxxo" />
        <AlertTitle mt={'-10px'}>Payment in progress</AlertTitle>
        <AlertDescription pl={'45px'} mt={'-10px'}>View your OXXO voucher for more details.</AlertDescription>
      </Alert>
      <Box mt={6}>
        <Button variant="dark" onClick={onViewVoucher} data-testid="voucher-submit-buttom">
          View voucher
        </Button>
      </Box>
    </Box>
  );
};
